import { useMemo } from "react";
import _ from "lodash";

import Box from "components/Box";
import SanitizeHtml from "components/SanitizeHtml";

import NoContent from "entities/Deal/components/OverviewSections/NoContent";
import { IDeal } from "entities/Deal/sdk";
import SectionContent from "entities/Memo/components/Sections/SectionContent";
import SectionHeader from "entities/Memo/components/Sections/SectionHeader";
import { IMemoSection } from "entities/Memo/sdk";
import { useDealSummaryByCategoryManager } from "entities/Memo/utils";

const PrintableSectionProjectNarrative = ({
  deal,
  sectionName = "",
  section,
  externalToken,
}: {
  deal: IDeal;
  sectionName?: string;
  section?: IMemoSection;
  externalToken?: string;
}) => {
  const { data } = useDealSummaryByCategoryManager({
    token: externalToken,
    dealId: deal.id,
    category: "executive_summary",
  });

  const showEmptyState = useMemo(
    () => !_.isUndefined(data) && data?.summary === "",
    [data]
  );

  return (
    <Box data-testid="project-narrative-section">
      <SectionHeader
        label={section?.title || sectionName}
        alignActionButton="right"
      />
      <SectionContent>
        <Box
          data-testid="section-description"
          sx={{
            "*": { lineHeight: "140% !important" },
            table: {
              width: "100%",
            },
            "table, th, td, tr": {
              borderCollapse: "collapse",
              border: "1px solid black !important",
            },
          }}
        >
          {showEmptyState ? (
            <NoContent />
          ) : (
            <SanitizeHtml
              html={data?.summary || ""}
              dataTestid="description-value"
            />
          )}
        </Box>
      </SectionContent>
    </Box>
  );
};

export default PrintableSectionProjectNarrative;
